var map = {
	"./ar.json": [
		26726,
		726
	],
	"./de.json": [
		39929,
		929
	],
	"./en.json": [
		20790,
		790
	],
	"./es.json": [
		18563,
		563
	],
	"./fr.json": [
		844,
		844
	],
	"./hu.json": [
		64626,
		626
	],
	"./it.json": [
		20504,
		504
	],
	"./ja.json": [
		8566,
		566
	],
	"./ko.json": [
		37697,
		697
	],
	"./pt.json": [
		69898,
		898
	],
	"./ru.json": [
		69672,
		672
	],
	"./zh-TW.json": [
		46687,
		687
	],
	"./zh.json": [
		66538,
		538
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 7535;
module.exports = webpackAsyncContext;